export const TRADER_AVATAR_INITIALS_TEST_ID = "trader-avatar-initials";
